import * as React from "react";
import styles from "./moneyBack.module.scss";
import Button from "../../../../components/button";

const MoneyBack = () => {
  return (
    <div className={styles.moneyBack} id="money-back">
      <div className={styles.content}>
        <img
          src="https://static.thenounproject.com/png/776827-200.png"
          alt=""
        />
        <h1>Love It or Your Money Back</h1>
        <p>
          We’re proud to have helped thousands of people find their beautiful
          complexion again and can’t wait for you to find yours. If for any
          reason CeroFace isn’t your new favorite beauty product, send it back,
          and we’ll refund 100% of your purchase.
        </p>

        <Button href="/cart" variant="white">
          RUSH MY ORDER{" "}
          <span role="img" aria-label="checkout">
            👉
          </span>
        </Button>
      </div>
    </div>
  );
};

export default MoneyBack;
